// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1MKxE","alertIcon":"ConfirmModal_alertIcon__64gDe"};